import useGetProductReviewAndRelatedData from './useGetProductReviewAndRelatedData'

export default useGetProductReviewAndRelatedData
